/* @flow */

import "./SearchResultNoArticle.scss";

import PropTypes from "prop-types";

import { FormattedMessage } from "react-intl";
import React from "react";
import { withReactAdapter } from "shared/src/module-federation/withReactAdapter";
import { Button, Well, Clearfix } from "react-bootstrap";
import Confirm from "../../../general/Confirm";
import { trackNoArticleData } from "../../../../utils/ArticleTrackingUtil";
import { SearchResultLayout } from "./SearchResultLayout";
import { OnListData } from "shared/src/types/ListItemRenderData";
import { withIntlRoot } from "shared/src/i18n/IntlRootMixin";

type Props = {
    item: string;
    onListData?: OnListData;
    inContainer?: boolean;
    searchResultLayout?: SearchResultLayout;
};

class SearchResultNoArticle extends React.Component<Props> {
    static contextTypes = {
        intl: PropTypes.object.isRequired
    };

    constructor(props: Props) {
        super(props);
    }

    deleteOneItem() {
        const onListData = this.props.onListData;
        if (onListData) {
            const data = {
                articleVariantId: this.props.item,
                parentBettyBundleId: onListData.bundleId
            };
            onListData.deleteAction(data, {
                listId: onListData.listId,
                listType: onListData.listType,
                listName: onListData.listName
            });
        }
    }

    renderContent() {
        return (
            <div className="mfcss_card-article-2 mfcss_card-article-2--not-found mfcss_card-article-2--type-default">
                <div className="mfcss_card-article-2--container-flex">
                    <div className="mfcss_card-article-2--image">
                        <img
                            src="/ordercapture/uidispatcher/static/app/assets/images/placeholder_food_item.png"
                            alt={this.context.intl.formatMessage(
                                { id: "EX_ARTICLE_FETCHING_FAILED" },
                                { item: this.props.item }
                            )}
                            className="img-responsive"
                        />
                    </div>
                    <div className="mfcss_card-article-2--info">
                        <div className="mfcss_card-article-2--title">
                            <h4>
                                <FormattedMessage id="EX_ARTICLE_FETCHING_FAILED" values={{ item: this.props.item }} />
                            </h4>
                        </div>
                    </div>
                    {this.props.onListData && (
                        <div className="mfcss_card-article-2--buttons">
                            <div className="mfcss_card-article-2--actions-delete">
                                <Confirm.Trigger
                                    confirm={() => {
                                        this.deleteOneItem();
                                    }}
                                    message={<FormattedMessage id="EX_ASK_TO_REMOVE" />}
                                    abortBtn={<FormattedMessage id="EX_CANCEL_MODAL" />}
                                    confirmBtn={<FormattedMessage id="EX_REMOVE" />}>
                                    <Button className="btn-square">
                                        <i className="icon-lg icon-trash" />
                                    </Button>
                                </Confirm.Trigger>
                            </div>
                            <Clearfix />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        trackNoArticleData(this.props.inContainer, this.props.item);
        if (this.props.inContainer) {
            return <span>{this.renderContent()}</span>;
        }
        return (
            <span>
                <Well className="well-sm">{this.renderContent()}</Well>
            </span>
        );
    }
}

export default withReactAdapter(withIntlRoot(SearchResultNoArticle));
